import { useState, useEffect } from "react";
import { subirDatos } from './syncSupabase';
import { authHeader } from './supabase';
import { generarPdfInstructivo } from './BotonInstructivo';
const MODULOS_ALQOS = [
  { key: "ncs", label: "No Conformidades", icon: "⚠️" },
  { key: "fmea", label: "FMEA", icon: "🔍" },
  { key: "plan_control", label: "Plan de Control", icon: "✅" },
  { key: "accionescorrectivas", label: "Acciones Correctivas", icon: "🔁" },
  { key: "auditorias", label: "Auditorías", icon: "🔎" },
  { key: "prog_auditorias", label: "Programa Auditorías", icon: "📅" },
  { key: "analisis_causa", label: "Análisis de Causa", icon: "🔬" },
  { key: "capabilidad", label: "Capabilidad / MSA", icon: "📊" },
  { key: "haccp", label: "HACCP", icon: "🧫" },
  { key: "poes", label: "POEs", icon: "📄" },
  { key: "ots", label: "Órdenes de Trabajo", icon: "📋" },
  { key: "documentos", label: "Documentos", icon: "📁" },
  { key: "ingreso_materiales", label: "Ingreso Materiales", icon: "📦" },
  { key: "preprensa", label: "Pre Prensa", icon: "🖨️" },
  { key: "produccion", label: "Producción", icon: "🏗️" },
  { key: "familias", label: "Familias y Líneas", icon: "🏭" },
  { key: "tpm", label: "TPM Mantenimiento", icon: "🔧" },
  { key: "huella_carbono", label: "Huella de Carbono", icon: "🌱" },
  { key: "fsc", label: "FSC Arqueo", icon: "🌿" },
  { key: "sustentabilidad", label: "Sustentabilidad", icon: "🌍" },
  { key: "proveedores", label: "Proveedores", icon: "🤝" },
  { key: "clientes", label: "Clientes", icon: "🤝" },
  { key: "compras", label: "Compras", icon: "🛒" },
  { key: "cotizacion", label: "Cotización", icon: "💰" },
  { key: "ventas", label: "Ventas", icon: "📈" },
  { key: "rrhh", label: "RRHH", icon: "👥" },
  { key: "capacitaciones", label: "Capacitaciones", icon: "🎓" },
  { key: "hs", label: "H&S", icon: "🦺" },
  { key: "ciberseguridad", label: "Ciberseguridad", icon: "🔐" },
  { key: "stock_materiales", label: "Stock Materiales", icon: "📦" },
  { key: "despacho", label: "Despacho", icon: "🚚" },
  { key: "aria", label: "ARIA — IA", icon: "🤖" },
  { key: "dashboard_ca", label: "Dashboard CA", icon: "🏅" },
  { key: "diseno_desarrollo", label: "Diseño y Desarrollo", icon: "✏️" },
  { key: "oficina_tecnica", label: "Oficina Técnica", icon: "📐" },
  { key: "especificaciones_tecnicas", label: "Especificaciones Técnicas", icon: "📌" },
  { key: "usuarios", label: "Usuarios", icon: "👥" },
  { key: "importar_csv", label: "Importar CSV", icon: "📥" },
  { key: "assured_quality", label: "Assured Quality", icon: "🏆" },
  { key: "trazabilidad", label: "Trazabilidad", icon: "🔗" },
  { key: "costos_no_calidad", label: "Costos de No Calidad", icon: "💸" },
  { key: "cumplimiento_normas", label: "Cumplimiento de Normas", icon: "📋" },
  { key: "comunicados", label: "Comunicados Internos", icon: "📢" },
  { key: "onboarding", label: "Onboarding", icon: "🚀" },
  { key: "escritorio_calidad", label: "Escritorio Calidad", icon: "🗂️" },
  { key: "consultor_hs", label: "Portal Asesores", icon: "🔍" },
  { key: "centros_costo", label: "Centros de Costo", icon: "⚙️" },
  { key: "motor_costeo", label: "Motor de Costeo", icon: "🧮" },
];

/* ── NUEVO: Programa de Capacitación ALQOS™ (transición/venta) ──
   Son "instructivos" igual que los de arriba, pero no representan un módulo
   operativo real — son las 7 fases del programa de capacitación armado para
   enseñarle a usar, administrar, vender y sostener ALQOS. Se guardan en la
   misma tabla de Supabase (instructivos), con estos module_key fijos, así
   que no hace falta ninguna migración de base de datos. */
const CAPACITACION_ALQOS = [
  { key: "cap_fase0", label: "Fase 0 — Fundamentos", icon: "🎓" },
  { key: "cap_fase1", label: "Fase 1 — Uso operativo", icon: "🎓" },
  { key: "cap_fase2", label: "Fase 2 — Administración", icon: "🎓" },
  { key: "cap_fase3", label: "Fase 3 — El negocio detrás", icon: "🎓" },
  { key: "cap_fase4", label: "Fase 4 — Por dentro, sin programar", icon: "🎓" },
  { key: "cap_fase5", label: "Fase 5 — Propiedad y continuidad", icon: "🎓" },
  { key: "cap_fase6", label: "Fase 6 — Vender de verdad", icon: "🎓" },
];

const STORAGE_KEY = 'alqos_instructivos';
const storage = {
  get: () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } },
  set: (v) => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch {} },
};
export default function Instructivos({ onVolver, oscuro, usuario }) {
  const [instructivos, setInstructivos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [vista, setVista] = useState("listado");
  const [moduloActivo, setModuloActivo] = useState(null);
  const [form, setForm] = useState({});
  const [cargandoARIA, setCargandoARIA] = useState(false);
  const [descripcionARIA, setDescripcionARIA] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [lector, setLector] = useState(null); // NUEVO: instructivo abierto en modo solo lectura
  useEffect(() => {
    async function cargar() {
      try {
        const { supabase } = await import('./supabase');
        const { data } = await supabase.from('instructivos').select('data');
        if (data && data.length > 0) setInstructivos(data.map(r => r.data));
        else setInstructivos(storage.get());
      } catch { setInstructivos(storage.get()); }
      setCargando(false);
    }
    cargar();
  }, []);
  const esAdmin = usuario?.rol === "Administrador";
  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };
  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: subtexto, fontWeight: "600", display: "block", marginTop: "12px" };
  if (cargando) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: bg }}>
      <p style={{ color: oscuro ? "white" : "#09184D", fontSize: "16px" }}>Cargando instructivos...</p>
    </div>
  );
  const guardar = () => {
    const existe = instructivos.find(i => i.modulo_key === form.modulo_key);
    let nuevos;
    if (existe) {
      const nuevaVersion = (parseFloat(existe.version || "1.0") + 0.1).toFixed(1);
      nuevos = instructivos.map(i => i.modulo_key === form.modulo_key ? {
        ...i, ...form,
        version: nuevaVersion,
        ultima_edicion: new Date().toISOString(),
        editado_por: usuario?.nombre,
        elaboradoPor: form.elaboradoPor || i.elaboradoPor,
        revisadoPor: form.revisadoPor || i.revisadoPor,
        aprobadoPor: form.aprobadoPor || i.aprobadoPor,
        historial: [...(i.historial || []), {
          fecha: new Date().toISOString(),
          version: i.version,
          editadoPor: usuario?.nombre
        }]
      } : i);
    } else {
      const nuevo = {
        ...form,
        id: Date.now(),
        version: "1.0",
        estado: "publicado",
        creado_por: usuario?.nombre,
        fecha_creacion: new Date().toISOString(),
        historial: []
      };
      nuevos = [...instructivos, nuevo];
    }
    setInstructivos(nuevos);
    storage.set(nuevos);
    subirDatos(STORAGE_KEY);
    setVista("listado");
    setForm({});
    setModuloActivo(null);
  };
  const abrirEditor = (moduloKey) => {
    const existente = instructivos.find(i => i.modulo_key === moduloKey);
    // NUEVO: además de MODULOS_ALQOS, ahora también busca en CAPACITACION_ALQOS
    const modulo = MODULOS_ALQOS.find(m => m.key === moduloKey) || CAPACITACION_ALQOS.find(m => m.key === moduloKey);
    setModuloActivo(modulo);
    setForm(existente || {
      modulo_key: moduloKey,
      titulo: `Instructivo — ${modulo?.label}`,
      contenido_texto: "",
      contenido_simple: "",
      estado: "publicado"
    });
    setDescripcionARIA("");
    setVista("editor");
  };
  // NUEVO: abre el visor de solo lectura (para cualquier usuario, no solo Administrador)
  const abrirLector = (moduloKey) => {
    const inst = instructivos.find(i => i.modulo_key === moduloKey && i.estado === "publicado");
    if (inst) setLector(inst);
  };
  const generarConARIA = async () => {
    if (!descripcionARIA.trim()) return;
    setCargandoARIA(true);
    try {
      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()),
          "Content-Type": "application/json",
          "anthropic-version": "2023-06-01",
          },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 2000,
          messages: [{
            role: "user",
            content: `Sos un experto en sistemas de gestión de calidad ISO 9001 y en redacción de instructivos operativos para pymes industriales.
Creá un instructivo de uso para el módulo "${moduloActivo?.label}" de ALQOS™, un sistema de gestión integral para pymes industriales.
Descripción proporcionada: "${descripcionARIA}"
Estructura requerida:
1. OBJETIVO: qué hace este módulo (2-3 líneas)
2. CUÁNDO USARLO: situaciones o disparadores
3. PASO A PASO: máximo 8 pasos numerados, claros y concretos
4. VINCULACIÓN CON OTROS MÓDULOS: qué genera o recibe
5. ERRORES FRECUENTES: 2-3 puntos a evitar
Tono profesional pero simple. Sin markdown, solo texto plano con numeración.`
          }]
        })
      });
      const data = await response.json();
      const contenido = data.content?.[0]?.text || "";
      setForm(f => ({ ...f, contenido_texto: contenido }));
      setDescripcionARIA("");
    } catch(e) {
      alert("Error con ARIA: " + e.message);
    }
    setCargandoARIA(false);
  };
  const simplificarConARIA = async () => {
    if (!form.contenido_texto?.trim()) { alert("Primero generá o escribí el instructivo técnico."); return; }
    setCargandoARIA(true);
    try {
      const response = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()),
          "Content-Type": "application/json",
          "anthropic-version": "2023-06-01",
          },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 2000,
          messages: [{
            role: "user",
            content: `Reescribí este instructivo en versión simplificada para operarios sin experiencia técnica.
Usá frases cortas, lenguaje cotidiano, sin tecnicismos.
Mantené la numeración y estructura pero hacélo muy fácil de entender.
Si hay términos técnicos o ISO, explicálos entre paréntesis.
Instructivo original:
${form.contenido_texto}`
          }]
        })
      });
      const data = await response.json();
      const simple = data.content?.[0]?.text || "";
      setForm(f => ({ ...f, contenido_simple: simple }));
    } catch(e) {
      alert("Error con ARIA: " + e.message);
    }
    setCargandoARIA(false);
  };
  const Header = ({ titulo, onBack }) => (
    <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", gap: "12px", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
      <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
      <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
    </div>
  );
  // ── EDITOR ──
  if (vista === "editor") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header titulo={`${moduloActivo?.icon} ${moduloActivo?.label}`} onBack={() => { setVista("listado"); setForm({}); }} />
      <div style={{ padding: "0 1.5rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#f5f3ff", border: "1px solid #7B5BF240" }}>
          <p style={{ fontSize: "13px", fontWeight: "700", color: "#7B5BF2", margin: "0 0 6px" }}>🤖 Generar con ARIA</p>
          <p style={{ fontSize: "12px", color: subtexto, margin: "0 0 8px" }}>Describí qué hace este módulo y ARIA redacta el instructivo completo</p>
          <textarea
            rows={3}
            value={descripcionARIA}
            onChange={e => setDescripcionARIA(e.target.value)}
            placeholder="Ej: En este módulo se registran las fallas detectadas en producción. El operario carga descripción, área y causa..."
            style={{ ...inp, resize: "vertical" }}
          />
          <button onClick={generarConARIA} disabled={cargandoARIA || !descripcionARIA.trim()}
            style={{ marginTop: "8px", padding: "8px 16px", background: cargandoARIA ? "#ccc" : "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: cargandoARIA ? "default" : "pointer", fontSize: "12px", fontWeight: "600" }}>
            {cargandoARIA ? "🤖 Generando..." : "🤖 Generar instructivo"}
          </button>
        </div>
        <div style={card}>
          <p style={{ fontSize: "13px", fontWeight: "700", color: texto, margin: "0 0 4px" }}>Título</p>
          <input value={form.titulo || ""} onChange={e => setForm(f => ({ ...f, titulo: e.target.value }))} style={inp} />
          <span style={lbl}>Elaborado por</span>
          <input value={form.elaboradoPor || ""} onChange={e => setForm(f => ({ ...f, elaboradoPor: e.target.value }))} style={inp} placeholder="Nombre y cargo" />
          <span style={lbl}>Revisado por</span>
          <input value={form.revisadoPor || ""} onChange={e => setForm(f => ({ ...f, revisadoPor: e.target.value }))} style={inp} placeholder="Nombre y cargo" />
          <span style={lbl}>Aprobado por</span>
          <input value={form.aprobadoPor || ""} onChange={e => setForm(f => ({ ...f, aprobadoPor: e.target.value }))} style={inp} placeholder="Nombre y cargo" />
          <span style={lbl}>Instructivo técnico (para jefe de calidad / admin)</span>
          <textarea
            rows={14}
            value={form.contenido_texto || ""}
            onChange={e => setForm(f => ({ ...f, contenido_texto: e.target.value }))}
            placeholder="Escribí o generá el instructivo con ARIA..."
            style={{ ...inp, resize: "vertical", lineHeight: "1.6" }}
          />
          <button onClick={simplificarConARIA} disabled={cargandoARIA || !form.contenido_texto?.trim()}
            style={{ marginTop: "8px", padding: "7px 14px", background: "none", border: "1px solid #7B5BF2", color: "#7B5BF2", borderRadius: "8px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>
            {cargandoARIA ? "🤖 Simplificando..." : "🤖 Simplificar para operarios"}
          </button>
          {form.contenido_simple && (
            <>
              <span style={lbl}>Versión simplificada (para operarios)</span>
              <textarea
                rows={10}
                value={form.contenido_simple}
                onChange={e => setForm(f => ({ ...f, contenido_simple: e.target.value }))}
                style={{ ...inp, resize: "vertical", lineHeight: "1.6", background: oscuro ? "#091840" : "#f0fdf4", borderColor: "#22c55e" }}
              />
            </>
          )}
          <span style={lbl}>Estado</span>
          <div style={{ display: "flex", gap: "8px", marginTop: "6px" }}>
            {["publicado", "borrador"].map(e => (
              <button key={e} onClick={() => setForm(f => ({ ...f, estado: e }))}
                style={{ padding: "6px 14px", borderRadius: "8px", fontSize: "12px", cursor: "pointer", fontWeight: "600", border: form.estado === e ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: form.estado === e ? "rgba(123,91,242,.1)" : cardBg, color: form.estado === e ? "#7B5BF2" : subtexto }}>
                {e === "publicado" ? "✅ Publicado" : "📝 Borrador"}
              </button>
            ))}
          </div>
        </div>
        {form.historial?.length > 0 && (
          <div style={card}>
            <p style={{ fontSize: "13px", fontWeight: "700", color: "#7B5BF2", margin: "0 0 8px" }}>📋 Historial de versiones</p>
            {form.historial.map((h, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: `0.5px solid ${borde}`, fontSize: "12px" }}>
                <span style={{ color: subtexto }}>{h.fecha?.slice(0, 10)}</span>
                <span style={{ color: texto }}>v{h.version}</span>
                <span style={{ color: subtexto }}>{h.editadoPor}</span>
              </div>
            ))}
          </div>
        )}
        {form.contenido_texto?.trim() && (
          <button onClick={() => generarPdfInstructivo(form).save(`Instructivo_${form.modulo_key || "alqos"}_preview.pdf`)}
            style={{ width: "100%", padding: "10px", background: "none", border: "1.5px solid #1C3FAA", color: "#1C3FAA", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: "pointer", marginTop: "1rem" }}>
            📄 Descargar PDF (previsualizar antes de guardar)
          </button>
        )}
        <button onClick={guardar} disabled={!form.contenido_texto?.trim()}
          style={{ width: "100%", padding: "14px", background: form.contenido_texto?.trim() ? "#7B5BF2" : "#ccc", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: form.contenido_texto?.trim() ? "pointer" : "default", marginTop: "0.6rem" }}>
          Guardar instructivo
        </button>
      </div>
    </div>
  );
  // ── LISTADO ──
  const modulosFiltrados = MODULOS_ALQOS.filter(m => m.label.toLowerCase().includes(busqueda.toLowerCase()));
  const publicados = instructivos.filter(i => i.estado === "publicado").length;
  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>📖 Instructivos ALQOS™</span>
        </div>
        <span style={{ fontSize: "12px", color: "rgba(255,255,255,.6)" }}>{publicados}/{MODULOS_ALQOS.length} publicados</span>
      </div>
      <div style={{ padding: "1.5rem" }}>
        <input
          placeholder="🔍 Buscar módulo..."
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ ...inp, marginBottom: "1rem" }}
        />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "10px" }}>
          {modulosFiltrados.map(modulo => {
            const inst = instructivos.find(i => i.modulo_key === modulo.key);
            const tieneContenido = inst?.estado === "publicado" && inst?.contenido_texto;
            return (
              <div key={modulo.key}
                onClick={() => esAdmin && abrirEditor(modulo.key)}
                style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1.5px solid ${tieneContenido ? "#22c55e40" : borde}`, cursor: esAdmin ? "pointer" : "default", transition: "box-shadow .2s" }}
                onMouseEnter={e => { if(esAdmin) e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"; }}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
                  <span style={{ fontSize: "20px" }}>{modulo.icon}</span>
                  {tieneContenido
                    ? <span style={{ fontSize: "10px", background: "#f0fdf4", color: "#22c55e", border: "1px solid #86efac", borderRadius: "6px", padding: "2px 6px", fontWeight: "600" }}>✓ Listo</span>
                    : <span style={{ fontSize: "10px", background: oscuro ? "#1e3a8a" : "#f5f3ff", color: subtexto, border: `1px solid ${borde}`, borderRadius: "6px", padding: "2px 6px" }}>Pendiente</span>
                  }
                </div>
                <p style={{ fontSize: "12px", fontWeight: "600", color: texto, margin: "0 0 2px" }}>{modulo.label}</p>
                {inst && <p style={{ fontSize: "10px", color: subtexto, margin: 0 }}>v{inst.version} · {inst.ultima_edicion?.slice(0,10) || inst.fecha_creacion?.slice(0,10)}</p>}
                {!inst && esAdmin && <p style={{ fontSize: "10px", color: "#7B5BF2", margin: 0 }}>+ Crear instructivo</p>}
              </div>
            );
          })}
        </div>

        {/* ══════════ NUEVO: sección Programa de Capacitación ══════════ */}
        <div style={{ marginTop: "2.5rem" }}>
          <p style={{ fontSize: "14px", fontWeight: "700", color: texto, margin: "0 0 4px" }}>🎓 Programa de Capacitación ALQOS™</p>
          <p style={{ fontSize: "12px", color: subtexto, margin: "0 0 12px" }}>
            Contenido de estudio para aprender a usar, administrar, entender el negocio y vender ALQOS —
            {esAdmin ? " hacé clic en una fase para cargar o editar su contenido." : " hacé clic en una fase para leerla."}
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "10px" }}>
            {CAPACITACION_ALQOS.map(modulo => {
              const inst = instructivos.find(i => i.modulo_key === modulo.key);
              const tieneContenido = inst?.estado === "publicado" && inst?.contenido_texto;
              const clickeable = esAdmin || tieneContenido;
              return (
                <div key={modulo.key}
                  onClick={() => { if (esAdmin) abrirEditor(modulo.key); else if (tieneContenido) abrirLector(modulo.key); }}
                  style={{ background: cardBg, borderRadius: "12px", padding: "1rem", border: `1.5px solid ${tieneContenido ? "#7B5BF260" : borde}`, cursor: clickeable ? "pointer" : "default", transition: "box-shadow .2s" }}
                  onMouseEnter={e => { if (clickeable) e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"; }}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
                    <span style={{ fontSize: "20px" }}>{modulo.icon}</span>
                    {tieneContenido
                      ? <span style={{ fontSize: "10px", background: "#f5f3ff", color: "#7B5BF2", border: "1px solid #ddd6fe", borderRadius: "6px", padding: "2px 6px", fontWeight: "600" }}>✓ Listo</span>
                      : <span style={{ fontSize: "10px", background: oscuro ? "#1e3a8a" : "#f5f3ff", color: subtexto, border: `1px solid ${borde}`, borderRadius: "6px", padding: "2px 6px" }}>Pendiente</span>
                    }
                  </div>
                  <p style={{ fontSize: "12px", fontWeight: "600", color: texto, margin: "0 0 2px" }}>{modulo.label}</p>
                  {inst && <p style={{ fontSize: "10px", color: subtexto, margin: 0 }}>v{inst.version}</p>}
                  {!inst && esAdmin && <p style={{ fontSize: "10px", color: "#7B5BF2", margin: 0 }}>+ Cargar contenido</p>}
                </div>
              );
            })}
          </div>
        </div>
        {/* ══════════ FIN sección nueva ══════════ */}

      </div>

      {/* ══════════ NUEVO: visor de solo lectura ══════════ */}
      {lector && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}
          onClick={e => { if (e.target === e.currentTarget) setLector(null); }}>
          <div style={{ background: cardBg, borderRadius: "16px", padding: "1.5rem", maxWidth: "720px", width: "100%", maxHeight: "85vh", overflowY: "auto", border: `1px solid ${borde}`, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
              <div>
                <p style={{ fontSize: "11px", color: "#7B5BF2", fontWeight: "600", margin: "0 0 4px", textTransform: "uppercase", letterSpacing: ".1em" }}>🎓 Capacitación ALQOS™</p>
                <p style={{ fontSize: "16px", fontWeight: "700", color: texto, margin: 0 }}>{lector.titulo}</p>
                <p style={{ fontSize: "11px", color: subtexto, margin: "3px 0 0" }}>v{lector.version}</p>
              </div>
              <button onClick={() => setLector(null)}
                style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: subtexto }}>✕</button>
            </div>
            <div style={{
              fontSize: "13px", color: texto, lineHeight: "1.7",
              whiteSpace: "pre-wrap",
              background: oscuro ? "#091840" : "#f9f9ff",
              borderRadius: "10px", padding: "1rem",
              border: `1px solid ${borde}`
            }}>
              {lector.contenido_texto}
            </div>
          </div>
        </div>
      )}
      {/* ══════════ FIN visor de solo lectura ══════════ */}
    </div>
  );
}
